import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "d-flex w-100 flex-column"
}
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_Loan = _resolveComponent("Loan")!
  const _component_Commission = _resolveComponent("Commission")!
  const _component_ZTill = _resolveComponent("ZTill")!
  const _component_CurrentAccount = _resolveComponent("CurrentAccount")!
  const _component_WithoutInvoice = _resolveComponent("WithoutInvoice")!
  const _component_AutoSales = _resolveComponent("AutoSales")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_CashPayment = _resolveComponent("CashPayment")!
  const _component_Remittance = _resolveComponent("Remittance")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DocumentWizard = _resolveComponent("DocumentWizard")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "elevation-0 w-100 w-md-75",
    style: {"margin":"auto","background":"$white !important"}
  }, {
    default: _withCtx(() => [
      (_ctx.showBTWizard)
        ? _withDirectives((_openBlock(), _createBlock(_component_v_window, {
            key: 0,
            modelValue: _ctx.wizardStep,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.wizardStep) = $event)),
            touchless: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
                    default: _withCtx(() => [
                      _cache[36] || (_cache[36] = _createElementVNode("span", null, "Faites votre choix", -1)),
                      _createVNode(_component_v_avatar, {
                        color: "primary lighten-2",
                        class: "subheading white--text",
                        size: "24",
                        textContent: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { subheader: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            class: _normalizeClass(["oss-list-item", _ctx.listItemClass]),
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.wizardStep = 2), ["stop"]))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_btn_next)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[37] || (_cache[37] = [
                                  _createTextVNode("J'ai une facture")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_v_list_item_subtitle, null, {
                                default: _withCtx(() => _cache[38] || (_cache[38] = [
                                  _createTextVNode("Facture d'achat ou de vente à importer ou déjà importée")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["class"]),
                          (_ctx.withoutInvoiceStepCount)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.nextToGeneralWithoutInvoiceStep()), ["stop"]))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createTextVNode("Je n'ai pas de facture")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[40] || (_cache[40] = [
                                      _createTextVNode("Facture perdue, commission bancaire, remboursement d'emprunt")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.zTillBT)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.wizardStep = 6), ["stop"]))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[41] || (_cache[41] = [
                                      _createTextVNode("Encaissement provenant de la caisse")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[42] || (_cache[42] = [
                                      _createTextVNode("Pour les commerces : Dépot d'espèce ou de chèques, CB, Ticket restaurant, ...")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.currentAccountBTItem)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => {
                                _ctx.reconciliationVue.currentAccountAccountableAccount =
                                    _ctx.reconciliationVue.getDefaultCurrentAccount();
                                _ctx.wizardStep = 7;
                            }, ["stop"]))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("C'est du " + _toDisplayString(_ctx.reconciliationVue.getCurrentAccountTitle()), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Apport ou remboursement du " + _toDisplayString(_ctx.reconciliationVue.getCurrentAccountTitle()), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
                    default: _withCtx(() => [
                      _cache[43] || (_cache[43] = _createElementVNode("span", null, "Trouver votre facture", -1)),
                      _createVNode(_component_v_avatar, {
                        color: "primary lighten-2",
                        class: "subheading white--text",
                        size: "24",
                        textContent: 2
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { subheader: "" }, {
                        default: _withCtx(() => [
                          (
                                _ctx.reconciliationVue.currentUser.profile.configuration.document
                                    .importPurchaseInvoice
                            )
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startUpload()))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$chevron_right",
                                    loading: _ctx.reconciliationVue.loadingDocument
                                  }, null, 8, ["loading"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[44] || (_cache[44] = [
                                      _createTextVNode("J'importe une facture")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[45] || (_cache[45] = [
                                      _createTextVNode("Le justificatif n'a pas été importé dans l'application")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.insideBank)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _ctx.chooseExisitingDocument
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_icon, {
                                    icon: "$chevron_right",
                                    loading: _ctx.reconciliationVue.loadingDocument
                                  }, null, 8, ["loading"])
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createTextVNode("Je choisis une facture importée")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                                      _createTextVNode("Le justificatif a déjà été importé dans l'application")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class", "onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => {
                            _ctx.wizardStep = 1;
                            _ctx.reconciliationVue.documentPanel = false;
                        }),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[48] || (_cache[48] = [
                          _createTextVNode(" Précédent ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
                    default: _withCtx(() => [
                      _cache[49] || (_cache[49] = _createElementVNode("span", null, "Justifier sans facture", -1)),
                      _createVNode(_component_v_avatar, {
                        color: "primary lighten-2",
                        class: "subheading white--text",
                        size: "24",
                        textContent: 2
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { subheader: "" }, {
                        default: _withCtx(() => [
                          (_ctx.withoutInvoiceBT)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.wizardStep = 8))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                                      _createTextVNode("Je n'ai pas la facture ou commission bancaire")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                                      _createTextVNode("Le justificatif est perdu ou il s'agit d'une commission bancaire")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.commissionBTItem)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 1,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.wizardStep = 5))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[52] || (_cache[52] = [
                                      _createTextVNode("Mouvement bancaire avec commission bancaire prelevé")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                                      _createTextVNode("Il s'agit d'une vente pour laquelle la commission a été prélevée par la banque")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.loanBTItem)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 2,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.wizardStep = 4))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                      _createTextVNode("C'est un emprunt")
                                    ])),
                                    _: 1
                                  }),
                                  (_ctx.loanBTItem.bt && _ctx.loanBTItem.bt.amount < 0)
                                    ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                        default: _withCtx(() => _cache[55] || (_cache[55] = [
                                          _createTextVNode("Il s'agit du remboursement d'un emprunt bancaire.")
                                        ])),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 1 }, {
                                        default: _withCtx(() => _cache[56] || (_cache[56] = [
                                          _createTextVNode("Il s'agit d'un prêt bancaire.")
                                        ])),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true),
                          (_ctx.showAutoSalesReconciliation)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 3,
                                class: _normalizeClass(_ctx.listItemClass),
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.wizardStep = 9))
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_btn_next)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list_item_title, null, {
                                    default: _withCtx(() => _cache[57] || (_cache[57] = [
                                      _createTextVNode("N'est pas à justifier (BNC médicaux)")
                                    ])),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_list_item_subtitle, null, {
                                    default: _withCtx(() => _cache[58] || (_cache[58] = [
                                      _createTextVNode("Pour les BNC médicaux il n'est pas oblitoire de justifier les encaissements ou décaissements")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["class"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        rounded: "",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.wizardStep = 1)),
                        size: "small"
                      }, {
                        default: _withCtx(() => _cache[59] || (_cache[59] = [
                          _createTextVNode(" Précédent ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loan, {
                    step: 3,
                    reconciliationVue: _ctx.reconciliationVue,
                    companyId: _ctx.reconciliationVue.companyId,
                    btItem: _ctx.loanBTItem,
                    onAdded: _cache[11] || (_cache[11] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.backToGeneralWithoutInvoiceStep()))
                  }, null, 8, ["reconciliationVue", "companyId", "btItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_Commission, {
                    step: 3,
                    reconciliationVue: _ctx.reconciliationVue,
                    companyId: _ctx.reconciliationVue.companyId,
                    btItem: _ctx.commissionBTItem,
                    onAdded: _cache[13] || (_cache[13] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.backToGeneralWithoutInvoiceStep()))
                  }, null, 8, ["reconciliationVue", "companyId", "btItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ZTill, {
                    step: 2,
                    reconciliationVue: _ctx.reconciliationVue,
                    zTillBT: _ctx.zTillBT,
                    onAdded: _cache[15] || (_cache[15] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.wizardStep = 1))
                  }, null, 8, ["reconciliationVue", "zTillBT"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 7 }, {
                default: _withCtx(() => [
                  _createVNode(_component_CurrentAccount, {
                    step: 2,
                    companyId: _ctx.reconciliationVue.companyId,
                    btItem: _ctx.currentAccountBTItem,
                    reconciliationVue: _ctx.reconciliationVue,
                    accountableAccount: _ctx.reconciliationVue.currentAccountAccountableAccount,
                    onAdded: _cache[17] || (_cache[17] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[18] || (_cache[18] = ($event: any) => (_ctx.wizardStep = 1))
                  }, null, 8, ["companyId", "btItem", "reconciliationVue", "accountableAccount"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_WithoutInvoice, {
                    step: 3,
                    companyId: _ctx.reconciliationVue.companyId,
                    btItem: _ctx.withoutInvoiceBT,
                    onAdded: _cache[19] || (_cache[19] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[20] || (_cache[20] = ($event: any) => (_ctx.backToGeneralWithoutInvoiceStep()))
                  }, null, 8, ["companyId", "btItem"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 9 }, {
                default: _withCtx(() => [
                  _createVNode(_component_AutoSales, {
                    step: 3,
                    companyId: _ctx.reconciliationVue.companyId,
                    btItem: _ctx.showAutoSalesReconciliation,
                    onAdded: _cache[21] || (_cache[21] = ($event: any) => (_ctx.wizardStep = 1)),
                    onCancel: _cache[22] || (_cache[22] = ($event: any) => (_ctx.backToGeneralWithoutInvoiceStep()))
                  }, null, 8, ["companyId", "btItem"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])), [
            [_vShow, !_ctx.documentWizard]
          ])
        : (_ctx.showDocWizard)
          ? (_openBlock(), _createBlock(_component_v_window, {
              key: 1,
              modelValue: _ctx.wizardStep,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.wizardStep) = $event)),
              touchless: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
                      default: _withCtx(() => [
                        _cache[60] || (_cache[60] = _createElementVNode("span", null, "Faites votre choix", -1)),
                        _createVNode(_component_v_avatar, {
                          color: "primary lighten-2",
                          class: "subheading white--text",
                          size: "24",
                          textContent: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_flex, { class: "text-center mb-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _cache[24] || (_cache[24] = ($event: any) => {
                                _ctx.reconciliationVue.bankTransactionPanel =
                                    !_ctx.reconciliationVue.bankTransactionPanel;
                                _ctx.reconciliationVue.documentPanel = false;
                                _ctx.reconciliationVue.reconciliationPanel = false;
                            }),
                              class: "btn",
                              rounded: "",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[61] || (_cache[61] = [
                                _createTextVNode(" Je cherche un mouvement bancaire ")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_flex, { class: "text-center mb-2" }, {
                          default: _withCtx(() => [
                            (_ctx.reconciliationVue.difference)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  loading: _ctx.reconciliationVue.loadingDocument,
                                  disabled: _ctx.reconciliationVue.loadingDocument,
                                  rounded: "",
                                  class: "btn",
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => {
                                _ctx.reconciliationVue.documentPanel = !_ctx.reconciliationVue.documentPanel;
                                _ctx.reconciliationVue.bankTransactionPanel = false;
                                _ctx.reconciliationVue.reconciliationPanel = false;
                            }),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[62] || (_cache[62] = [
                                    _createTextVNode(" Je choisis une facture importée ")
                                  ])),
                                  _: 1
                                }, 8, ["loading", "disabled"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_flex, { class: "text-center mb-2" }, {
                          default: _withCtx(() => [
                            (_ctx.reconciliationVue.cashPaymentDocItem)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => {
                                _ctx.wizardStep = 2;
                                _ctx.reconciliationVue.bankTransactionPanel = false;
                            }),
                                  class: "btn",
                                  rounded: "",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[63] || (_cache[63] = [
                                    _createTextVNode("Cette facture a été réglée en espèce ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_flex, { class: "text-center mb-2" }, {
                          default: _withCtx(() => [
                            (_ctx.reconciliationVue.cashPaymentDocItem)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 0,
                                  onClick: _cache[27] || (_cache[27] = ($event: any) => {
                                _ctx.wizardStep = 3;
                                _ctx.reconciliationVue.bankTransactionPanel = false;
                            }),
                                  class: "btn",
                                  rounded: "",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => _cache[64] || (_cache[64] = [
                                    _createTextVNode("Cette facture a été payée par un chèque ou un prélèvement ou un virement non encaissé ")
                                  ])),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          rounded: "",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => {
                            _ctx.wizardStep = 1;
                            _ctx.reconciliationVue.bankTransactionPanel = false;
                        }),
                          size: "small"
                        }, {
                          default: _withCtx(() => _cache[65] || (_cache[65] = [
                            _createTextVNode(" Précédent ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CashPayment, {
                      step: 2,
                      userId: _ctx.reconciliationVue.currentUser.id,
                      companyId: _ctx.reconciliationVue.companyId,
                      accountingLine: _ctx.reconciliationVue.cashPaymentDocItem.accountingLine,
                      onAdded: _cache[29] || (_cache[29] = ($event: any) => (_ctx.wizardStep = 1)),
                      onCancel: _cache[30] || (_cache[30] = ($event: any) => (_ctx.wizardStep = 1))
                    }, null, 8, ["userId", "companyId", "accountingLine"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Remittance, {
                      step: 3,
                      userId: _ctx.reconciliationVue.currentUser.id,
                      companyId: _ctx.reconciliationVue.companyId,
                      accountingLine: _ctx.reconciliationVue.cashPaymentDocItem.accountingLine,
                      onAdded: _cache[31] || (_cache[31] = ($event: any) => (_ctx.wizardStep = 1)),
                      onCancel: _cache[32] || (_cache[32] = ($event: any) => (_ctx.wizardStep = 1))
                    }, null, 8, ["userId", "companyId", "accountingLine"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_v_card_title, { class: "title font-weight-regular justify-space-between d-flex" }, {
                default: _withCtx(() => [
                  _cache[67] || (_cache[67] = _createElementVNode("span", null, "Statut", -1)),
                  _createVNode(_component_v_avatar, {
                    color: "secondary",
                    class: "subheading white--text",
                    size: "24"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { dark: "" }, {
                        default: _withCtx(() => _cache[66] || (_cache[66] = [
                          _createTextVNode("$check")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_flex, {
                    xs12: "",
                    class: "ma-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.status), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 64)),
      (_ctx.documentWizard)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_DocumentWizard, {
              companyId: _ctx.reconciliationVue.companyId,
              showFirstPrevious: true,
              amount: -_ctx.reconciliationVue.difference,
              documentType: _ctx.documentType,
              multiple: false,
              onNewDocument: _ctx.onNewDocument,
              onClose: _cache[34] || (_cache[34] = ($event: any) => (_ctx.documentWizard = false)),
              onGlobalStep: _ctx.onGlobalStepChange,
              onFilesUploaded: _ctx.onFileUploaded
            }, null, 8, ["companyId", "amount", "documentType", "onNewDocument", "onGlobalStep", "onFilesUploaded"]),
            (_ctx.showDocumentWizardPreviousBtn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_v_btn, {
                    block: false,
                    size: "small",
                    class: "ma-3",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => {
                        _ctx.wizardStep = 2;
                        // reconciliationVue.documentPanel = false;
                        _ctx.documentWizard = false;
                    })
                  }, {
                    default: _withCtx(() => _cache[68] || (_cache[68] = [
                      _createTextVNode("Précédent")
                    ])),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}